import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { getSorting } from '../../../../../../../../store/model';
import { SegmentListEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { isAllowSorting } from '../../../../../../../../store/model/authUser/selectors/isAllowSorting';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';
import { root } from '../../../../../../../../store/constants';
import { setSorting } from '../../CardsSortingHOC/effects/setSorting';

export const toggleCardsSorting: ActionCreator<ThunkAction> = (
    listId: number,
    isSortingEnabled?: boolean
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const sorting = getSorting(getState(), listId);
        const isEnabled = isSortingEnabled === false ? isSortingEnabled : !sorting.isEnabled;
        const state = getState();
        const isAllow = isAllowSorting(state);
        if (!isAllow && isEnabled) {
            dispatch(showSnoozeBlocker({
                allow: 'allowPriorityAutoSorting'
            }));
            dispatch(segmentTrackAction(SegmentListEvent.SORTING_DENIED));
        } else if (
            !isAllow &&
            !isEnabled &&
            root.App.controller.allowCounterSnackbarHelper.isShowSnackbar('allowPriorityAutoSorting')
        ) {
            return Promise.resolve(false);
        } else {
            const segmentEvent = isEnabled ? SegmentListEvent.SORTING_ON : SegmentListEvent.SORTING_OFF;
            dispatch(segmentTrackAction(segmentEvent));
            dispatch(setSorting(listId, { ...sorting, isEnabled }));
            return Promise.resolve(true);
        }
    };
    return action;
};
